export const convertUserToSelect = user => ({
    label: `${user.firstname} ${user.lastname}`,
    value: user.id
});
